import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import './ClientsUploadingView.css';
import * as analytics from '../../services/analytics';
import get from 'lodash/get';

const propTypes = {
  getCSVUploadStatus: PropTypes.func,
};

const defaultProps = {
  getCSVUploadStatus: () => {},
};

class ClientsUploadingView extends PureComponent {
  componentDidMount() {
    const {
      getCSVUploadStatus,
      onNotifySuccess,
      onNotifyError,
      onUploadComplete,
    } = this.props;
    analytics.page('Broker Portal - Clients Uploading');
    this.interval = setInterval(() => {
      getCSVUploadStatus().then((resp) => {
        if (resp.done) {
          if (!get(resp, 'result.response.error')) {
            clearInterval(this.interval);
            onNotifySuccess('Clients added successfully');
            onUploadComplete();
          } else {
            onNotifyError(resp.result.response.error);
            onUploadComplete();
          }
        }
      });
    }, 3000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    return (
      <div className="ClientsUploadingView">
        <div className="row justify-content-center align-items-center">
          <div className="col-4">
            <div className="card">
              <span className="ClientsUploadingView-icon fa-stack fa-2x fa-fw m-t-20">
                <i
                  className="far fa-circle fa-stack-2x"
                  style={{ color: '#e6e6e6' }}
                />
                <i className="fas fa-cloud-upload-alt fa-stack-1x" />
              </span>
              <h2 className="ClientsUploadingView-heading">
                Please wait while we import your client list…
              </h2>
              <div style={{ width: '100%' }}>
                <div className="progress">
                  <div className="progress-bar-indeterminate progress-bar-complete" />
                </div>
              </div>
              <p className="ClientsUploadingView-disclaimer">
                Your clients will never be contacted for the marketing of
                additional products or services without your permission.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ClientsUploadingView.propTypes = propTypes;
ClientsUploadingView.defaultProps = defaultProps;

export default ClientsUploadingView;
